import { cn } from "@/lib/cn";

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "animate-shimmer rounded-md bg-neutral-100 bg-[linear-gradient(90deg,theme(colors.neutral.100)_0px,theme(colors.neutral.150)_40px,theme(colors.neutral.100)_80px)] bg-[length:400px_100%]",
        className
      )}
    />
  );
}

/** Placeholder for a list or table while it loads. */
export function TableSkeleton({ rows = 6, cols = 4, label = "Loading" }: { rows?: number; cols?: number; label?: string }) {
  return (
    <div className="space-y-2 p-4" role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} className="h-9 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}

/** Placeholder for a card (a settings block, a chart, a summary) while it loads. */
export function CardSkeleton({ lines = 3, label = "Loading" }: { lines?: number; label?: string }) {
  return (
    <div className="space-y-3 rounded-xl bg-white p-4 ring-1 ring-inset ring-neutral-200" role="status" aria-live="polite">
      <span className="sr-only">{label}</span>
      <Skeleton className="h-5 w-1/3" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>
  );
}
